"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTagEventSeriesProperty = exports.tagEventSeriesPropertyDefinition = void 0;
exports.tagEventSeriesPropertyDefinition = {
    view: {
        label: 'Event Series',
        style: '',
        hint: 'Related to an event series? Tag it and the asset shows on the event collection page.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['event-series'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'tag-event-series',
};
const isTagEventSeriesProperty = (prop) => {
    return prop.name === exports.tagEventSeriesPropertyDefinition.name;
};
exports.isTagEventSeriesProperty = isTagEventSeriesProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLWV2ZW50LXNlcmllcy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3RhZy1ldmVudC1zZXJpZXMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQ0FBZ0MsR0FBRztJQUM5QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsY0FBYztRQUNyQixLQUFLLEVBQUUsRUFBRTtRQUNULElBQUksRUFBRSxzRkFBc0Y7S0FDN0Y7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLGNBQWMsQ0FBQztTQUMzQjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxrQkFBa0I7Q0FDTyxDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=